import { LS_ACCESS_TOKEN_KEY, LS_REFRESH_TOKEN_KEY, WALLET_PROVIDER_KEY, GIFT_CODE_KEY, GIFT_CODE_EXPIRATION_KEY, MKP_PREFIX, ADS_POPUP_KEY, ONBOARDING_KEY, DAILY_CHECKIN_KEY } from 'src/constants';
import { WalletProvider } from './types';
export const storeSession = (accessToken, refreshToken) => {
  localStorage.setItem(LS_ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(LS_REFRESH_TOKEN_KEY, refreshToken);
  return {
    accessToken,
    refreshToken
  };
};
export const clearSession = () => {
  localStorage.removeItem(LS_ACCESS_TOKEN_KEY);
  localStorage.removeItem(LS_REFRESH_TOKEN_KEY);
};
export const getSession = () => {
  const accessToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
  const refreshToken = localStorage.getItem(LS_REFRESH_TOKEN_KEY);

  if (!accessToken || !refreshToken) {
    clearSession();
    return undefined;
  }

  return {
    accessToken,
    refreshToken
  };
};
export const storePreferredWalletProviderName = provider => {
  localStorage.setItem(WALLET_PROVIDER_KEY, provider);
};
export const clearPreferredWalletProviderName = () => {
  localStorage.removeItem(WALLET_PROVIDER_KEY);
};
export const getPreferredWalletProviderName = () => {
  const provider = localStorage.getItem(WALLET_PROVIDER_KEY);

  if (!provider || ![WalletProvider.METAMASK.toString(), WalletProvider.COINBASE.toString(), WalletProvider.WALLET_CONNECT.toString(), WalletProvider.SEQUENCE.toString(), WalletProvider.THETAN_WALLET.toString()].includes(provider)) {
    return undefined;
  }

  return provider;
};
export const storeGiftCode = ({
  code,
  expAt
}) => {
  const EXPIRE_NEXT_WEEK = Date.now() + 7 * 24 * 60 * 60 * 1000;
  const expiry = expAt ? Math.min(Number(expAt) * 1000, EXPIRE_NEXT_WEEK) : EXPIRE_NEXT_WEEK; // 1 week

  localStorage.setItem(GIFT_CODE_KEY, code);
  localStorage.setItem(GIFT_CODE_EXPIRATION_KEY, expiry.toString());
  return {
    code,
    expiry
  };
};
export const clearGiftCode = () => {
  localStorage.removeItem(GIFT_CODE_KEY);
  localStorage.removeItem(GIFT_CODE_EXPIRATION_KEY);
};
export const getGiftCode = () => {
  const giftCode = localStorage.getItem(GIFT_CODE_KEY);
  const expAt = localStorage.getItem(GIFT_CODE_EXPIRATION_KEY);

  if (!giftCode || !expAt) {
    clearGiftCode();
    return undefined;
  }

  try {
    const expiry = Number.parseInt(expAt);

    if (expiry < Date.now()) {
      clearGiftCode();
      return undefined;
    }

    return giftCode;
  } catch (err) {
    clearGiftCode();
    return undefined;
  }
};

const getItem = key => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const setItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    return false;
  }
};

export const storeAdsPopupTimestamp = (name, value, prefix = MKP_PREFIX) => {
  const combinedKey = `${prefix}.${ADS_POPUP_KEY}.${name}`;
  setItem(combinedKey, value.toString());
};
export const getAdsPopupTimestamp = (name, prefix = MKP_PREFIX) => {
  const combinedKey = `${prefix}.${ADS_POPUP_KEY}.${name}`;
  const result = getItem(combinedKey);
  return result ? Number(result) : null;
};
export const getOnboardingInfo = () => {
  const result = localStorage.getItem(ONBOARDING_KEY);
  return result ? JSON.parse(result) : null;
};
export const setOnboardingInfo = value => {
  try {
    localStorage.setItem(ONBOARDING_KEY, JSON.stringify(value));
    return true;
  } catch (error) {
    return false;
  }
};
export const setExpiryDailyCheckin = (addressId, expiredTime) => {
  try {
    localStorage.setItem(`${DAILY_CHECKIN_KEY}_${addressId}`, expiredTime.toString());
    return true;
  } catch (error) {
    return false;
  }
};
export const getExpiryDailyCheckin = addressId => {
  const result = localStorage.getItem(`${DAILY_CHECKIN_KEY}_${addressId}`);
  return result ? parseInt(result) : null;
};
export const clearExpiryDailyCheckin = addressId => {
  localStorage.removeItem(`${DAILY_CHECKIN_KEY}_${addressId}`);
};